'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

type CardBodyProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};
export const CardBody = ({ children, ...props }: CardBodyProps) => {
  return <div {...props}>{children}</div>;
};
